import 'babel-polyfill';
import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './application-router.js';
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import "./timeline.css";
import "./star.css";
import "./wizard.css";
import './payment.css';
import './css/tables.css';
import './css/wizard.css';
import './css/datepicker.css';
import './select-csss.css';
import './css/react-bootstrap-table.css';
import './css/checkbox.css'

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);
root.render(<App />);
